module.exports = __webpack_public_path__ + "img/fill-image.f2e00319.svg";